import React, { memo, useEffect } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import { createStructuredSelector } from "reselect";
import get from "lodash/get";

import {
  clearData,
  fetchTransactionDetails,
  postPaymentRequest
} from "ducks/actions";
import {
  makeSelectTransactionDetails,
  makeSelectTransactionAmount,
  makeSelectIsFetchingData,
  makeSelectShopPaymentForm,
  makeSelectShopPaymentPayload,
  makeSelectShopPaymentFormInitialValues
} from "ducks/selectors";

import SmartRender from "containers/SmartRender";
import { forms } from "utils/constants";
import { urlParam, getGopayActionUrls } from "utils/helpers";
import Spinner, { styles } from "components/Spinner";

const PaymentHOC = Component =>
  function Comp(props) {
    const {
      isFetchingTransactionDetails,
      clearPaymentRequest,
      fetchTransactionDetails
    } = props;

    useEffect(
      () => {
        clearPaymentRequest();
        fetchTransactionDetails();
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      []
    );

    return isFetchingTransactionDetails ? (
      <Spinner size={200} sx={styles.fullPage} />
    ) : (
      <Component {...props} />
    );
  };

const mapStateToProps = createStructuredSelector({
  formValues: makeSelectShopPaymentForm(),
  payload: makeSelectShopPaymentPayload(),
  transactionDetails: makeSelectTransactionDetails(),
  transactionAmount: makeSelectTransactionAmount(),
  isFetchingTransactionDetails: makeSelectIsFetchingData("transactionDetails"),
  isFetchingPaymentRequest: makeSelectIsFetchingData("paymentRequest"),
  initialValues: makeSelectShopPaymentFormInitialValues()
});

function mapDispatchToProps(dispatch) {
  return {
    clearPaymentRequest: () => {
      dispatch(clearData("paymentRequest"));
    },
    fetchTransactionDetails: () => {
      const txn_id = urlParam("id");
      if (txn_id) {
        dispatch(fetchTransactionDetails({ txn_id }));
      }
    },
    onSubmit: (_, payload) => {
      dispatch(
        postPaymentRequest(payload, result => {
          const request_url = get(result, "request_url");
          const { deepLinkUrl } = getGopayActionUrls(result);
          if (deepLinkUrl) {
            // redirect to deep link
            window.location.replace(deepLinkUrl);
          } else if (request_url) {
            window.location.replace(request_url);
          }
        })
      );
    }
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(
  withConnect,
  reduxForm({
    form: forms.SHOP_PAYMENT_FORM,
    destroyOnUnmount: false
  }),
  memo
)(PaymentHOC(SmartRender));
